export const METAMASK_PROMO_COOKIE = 'tokentax-metamask-promo';
